module.exports = __webpack_public_path__ + "static/background-2-473f43f0c9543cab25d0879f72c5dbd1.svg";